<template>
    <div class="row content-presets">
        <div class="col-md-6">
            <div class="ibox no-border type-list-box">
                <div class="typelist-title">
                    <div class="ibox-tools ibox-title bg-primary" v-cloak>
                        <h5 class="title"> {{ t_element_types }} </h5>
                    </div>
                </div>
                <div class="ibox-content" ref="typelist-content">
                    <div class="panel-body scrollBox clearfix" ref="typelist" :style="'height:' + (typelistHeight) + 'px;'">
                        <div class="type-list">
                            <div v-for="currentType in allElementTypes"
                                :class="[elementsPerRowClass, 'mediapool-small file-box mediapool-file-box element']"
                                 data-type="text">
                                <div class="file no-selection" @click="elementType=currentType">
                                    <div class="image-container icon">
                                        <eicon :kind="icon(currentType)"></eicon>
                                    </div>
                                    <div class="file-name wrap-text mediapool-file-name">
                                        <strong>{{ title(currentType) }}</strong>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <div id="settings" class="float-e-margins ibox">
                <div class="settings-title">
                    <div class="ibox-tools ibox-title bg-primary" v-cloak>
                        <h5 class="title"> {{ title(elementType) }} </h5>
                    </div>
                </div>

                <div class="ibox-content settings-content">
                    <div class="row">
                        <div class="col-md-12">
                            <ul class="nav nav-tabs">
                                <li v-for="currentType in allContentTypes" :class="['dragdrop-nav-tab', contentType===currentType ? 'active' : '']" @click.passive="toggle(false)">
                                    <a data-toggle="tab" href="#tab-1" @click.passive="contentType=currentType">
                                        <eicon kind="icon(currentType)" class="fa-fw"></eicon>&nbsp;{{ title(currentType) }}
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="tabs-container">
                        <div class="tab-content">
                            <div class="scrollBox" ref="scrollBox" :style="'height:' + settingsHeight + 'px;'" @scroll="scrolled">
                                <div class="noCollapse"
                                     v-if="sectionAvailable('no_collapse')">
                                    <div v-if="creator === false" class="alert alert-danger">
                                        <div>{{ t_creator_invalid }}</div>
                                        <template v-for="element in creator_errors">
                                            <template v-if="element && element.hidden === false && element.errors.length > 0">
                                                <div>{{ element.name }}</div>
                                                <ul>
                                                    <li v-for="error in element.errors">
                                                        {{ error }}
                                                    </li>
                                                </ul>
                                            </template>
                                        </template>
                                    </div>

                                    <playbackSettings
                                        v-model="inner_properties"
                                        :definition="elementProperties()"
                                        :duration-privilege="durationPrivilege"
                                        :is_parent="false"
                                        v-on:initToBeScrolled="initToBeScrolled($event['type'], $event['id'])"
                                        v-on:leaveElementToBeScrolled="leaveElementToBeScrolled()"
                                        clearable="1">
                                    </playbackSettings>

                                    <common-no-collapse-settings
                                        v-model="inner_properties"
                                        :definition="elementProperties()"
                                        :all_layer_layers="all_layer_layers"
                                        :parent_layers="[]"
                                        v-on:initToBeScrolled="initToBeScrolled($event['type'], $event['id'])"
                                        v-on:leaveElementToBeScrolled="leaveElementToBeScrolled()"
                                        clearable="1">
                                    </common-no-collapse-settings>
                                </div>

                                <collapse :title="t_font" name="fontcollapse"
                                          v-if="sectionAvailable('font')">
                                    <font-settings
                                        v-model="inner_properties"
                                        :definition="elementProperties()"
                                        v-on:initToBeScrolled="initToBeScrolled($event['type'], $event['id'])"
                                        v-on:leaveElementToBeScrolled="leaveElementToBeScrolled()"
                                        clearable="1">
                                    </font-settings>
                                </collapse>

                                <collapse :title="t_extended_properties" name="Extended"
                                          v-if="sectionAvailable('extended')">
                                    <extended-settings
                                        v-model="inner_properties"
                                        :definition="elementProperties()"
                                        v-on:initToBeScrolled="initToBeScrolled($event['type'], $event['id'])"
                                        v-on:leaveElementToBeScrolled="leaveElementToBeScrolled()"
                                        clearable="1">
                                    </extended-settings>
                                </collapse>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import commonNoCollapseSettings from "../content/settings/commonNoCollapseSettings";
    import playbackSettings from "../content/settings/playbackSettings";
    import fontSettings from "../content/settings/fontSettings";
    import extendedSettings from "../content/settings/extendedSettings";
    import commonSettingsMixin from "../content/settings/commonSettingsMixin";

    import {elementsSettingsDefaults, elementsSettingsLimits, elementsSettingsDefinition, elementsSettingsEmpty} from '../content/settings/settingsDefinition.js';

    export default {
        components: {
            commonNoCollapseSettings,
            playbackSettings,
            fontSettings,
            extendedSettings,
        },
        mixins: [
            commonSettingsMixin,
        ],
        props: [
            'project_id',
            'content_presets',
            'all_layers',
        ],
        data: function () {
            return {
                inner_content_presets: {},
                inner_properties: {},
                allElementTypes: [],
                allContentTypes: ["all", "template", "campaign", "publish"],
                allTandFa: {
                    picture: [Lang.langChoice("Picture|Pictures", 1), 'picture'],
                    pdf: [Lang.langChoice("PDF|PDFs", 1), 'pdf'],
                    video: [Lang.langChoice("Video|Videos", 1), 'video'],
                    ppt: [Lang.langChoice("PowerPoint|PowerPoints", 1), 'ppt'],

                    text: [Lang.langGet("Text"), 'text'],
                    iframe: [Lang.langGet("Web"), 'web'],
                    youtube: [Lang.langGet("YouTube"), 'youtube'],
                    countdown: [Lang.langGet("Countdown"), 'countdown'],
                    qrcode: [Lang.langGet("QR Code"), 'qrcode'],
                    emptyrectangle: [Lang.langGet("Empty Rectangle"), 'empty-rectangle'],
                    clock: [Lang.langGet("Clock"), 'clock'],
                    day: [Lang.langGet("Day"), 'day'],
                    weather: [Lang.langGet("Weather"), 'weather'],
                    layer: [Lang.langGet("Layer"), 'layer'],
                    esign: [Lang.langGet("eSign"), 'esign'],
                    rssfeed: [Lang.langGet("RSS Feed"), 'rss'],

                    all: [Lang.langGet("All"), 'square-open'],
                    template: [Lang.langChoice("Template|Templates", 1), 'template'],
                    campaign: [Lang.langChoice("Campaign|Campaigns", 1), 'campaign'],
                    publish: [Lang.langGet("Publish"), 'rocket'],
                },
                all_layer_layers: [],
                elementType: "",
                contentType: "",
                creator: true,
                elementsPerRowClass: '',
                typelistHeight: 700,

                durationPrivilege: true,

                t_element_types: Lang.langGet("Types of elements"),
            };
        },
        watch: {
            elementType: function () {
                this.updateInnerProperties();
            },
            contentType: function () {
                this.updateInnerProperties();
            },
            inner_content_presets: {
                handler: function () {
                    if(JSON.stringify(this.inner_content_presets) === this.content_presets) {
                        return;
                    }

                    axios.post('/administration/content-presets/edit', {
                        inner_content_presets: this.inner_content_presets,
                        project_id: this.project_id
                    }).then(() => {
                        EaseEventBus.fire('hideModal', this.modalName);
                        $('#client-table').DataTable().draw();
                    }).catch((error) => {
                        this.saving = false;

                        if (error.response.status === 401) {
                            window.location = '/login';
                        } else if (error.response.status === 422) {
                            let tmpErrors = {};

                            for (let key in error.response.data.errors) {
                                tmpErrors[key] = error.response.data.errors[key][0];
                            }
                            this.errors = _.extend({}, this.errors, tmpErrors);
                        } else {
                            this.errors = _.extend({}, this.errors, {'general': Lang.langGet("Failed to modify client in database.")});
                        }
                    });
                },
                deep: true
            }
        },
        methods: {
            title: function (elementType) {
                if(this.allTandFa[elementType] && this.allTandFa[elementType].length === 2) {
                    return this.allTandFa[elementType][0];
                }
                return elementType;
            },
            icon: function (elementType) {
                if(this.allTandFa[elementType] && this.allTandFa[elementType].length === 2) {
                    return this.allTandFa[elementType][1];
                }
                return elementType;
            },
            contentIcon: function (elementType) {
                if(this.allTandFa[elementType] && this.allTandFa[elementType].length === 2) {
                    return this.allTandFa[elementType][1];
                }
                return elementType;
            },
            processWindowSize: function () {
                let typelistContent = this.$refs['typelist-content'];
                let typelist = this.$refs['typelist'];
                let elementsPerRowClass = 'three-in-a-row';

                if (typelistContent !== undefined && typelistContent !== undefined) {
                    let width = typelistContent.getBoundingClientRect().width;

                    if (width > 900) {
                        elementsPerRowClass = 'five-in-a-row';
                    } else if (width > 700) {
                        elementsPerRowClass = 'four-in-a-row';
                    } else if (width > 500) {
                        elementsPerRowClass = 'three-in-a-row';
                    } else {
                        elementsPerRowClass = 'two-in-a-row';
                    }

                    let settingsContent = this.$refs['scrollBox'];
                    let app = document.getElementById('app');
                    let footer = document.getElementById('app-footer');
                    if (app && footer && settingsContent) {
                        let height = app.getBoundingClientRect().height;
                        let top = settingsContent.getBoundingClientRect().top;
                        let footerHeight = footer.getBoundingClientRect().height;
                        let marginBottom = 20;
                        this.settingsHeight = Math.max(300, height - footerHeight - top - marginBottom);
                        top = typelist.getBoundingClientRect().top;
                        marginBottom = 20 + 15;
                        this.typelistHeight = Math.max(300, height - footerHeight - top - marginBottom);
                    }
                }
                this.elementsPerRowClass = elementsPerRowClass;


            },
            updateInnerProperties: function () {
                this.loadDefinition();
                this.inner_properties = this.inner_content_presets[this.elementType][this.contentType];

                if(this.inner_properties === undefined) {
                    return;
                }

                if (this.inner_properties.text_direction === 'rtl' && typeof this.inner_properties.text !== 'undefined') {
                    this.inner_properties.text = this.inner_properties.text.split('').reverse().join('');
                }

                if (
                    typeof this.watch_text_direction[this.inner_properties['index']] === 'undefined' ||
                    this.watch_text_direction[this.inner_properties['index']] !== this.inner_properties.text_direction
                ) {
                    if (this.inner_properties.text_direction === 'rtl' && this.inner_properties.text_align === 'left') {
                        this.inner_properties.text_align = 'right';
                    }

                    if (this.inner_properties.text_direction === 'ltr' && this.inner_properties.text_align === 'right') {
                        this.inner_properties.text_align = 'left';
                    }
                }

                this.watch_text_direction[this.inner_properties['index']] = this.inner_properties.text_direction;
            },
            loadDefinition: function () {
                this.loadDefinitionForType(this.elementType, this.contentType);
            },
            initProperties: function (elementType, alreadySetValues=[]) {
                let allProperties = this.getPropertiesForType(elementType);
                //FILL VALUES
                let content_presets_for_type = {};
                _.each(allProperties, (contentProperties, contentType) => {
                    content_presets_for_type[contentType] = {};
                    let alreadySetValues_Content = [];
                    if(alreadySetValues[contentType]) {
                        alreadySetValues_Content = alreadySetValues[contentType];
                    }
                    _.each(contentProperties, (key) => {
                        content_presets_for_type[contentType][key] = alreadySetValues_Content[key] ? alreadySetValues_Content[key] : this.emptyValue(key);
                    });
                });
                return content_presets_for_type;
            },
            defaultValue: function (elementType, field) {
                if (elementType in elementsSettingsDefaults && field in elementsSettingsDefaults[elementType]) {
                    return elementsSettingsDefaults[elementType][field];
                } else if ("default" in elementsSettingsDefaults && field in elementsSettingsDefaults["default"]) {
                    return elementsSettingsDefaults["default"][field];
                }
                return "";
            },
            emptyValue: function (field) {
                return elementsSettingsEmpty[field] ? elementsSettingsEmpty[field] : "";
            },
            getPropertiesForType: function (elementType) {
                let properties = {};
                _.each(this.getDefinitionForType(elementType), function(contentProperties, contentType) {
                    let contentPropertiesNames = [];
                    _.each(contentProperties, function(section) {
                        contentPropertiesNames = contentPropertiesNames.concat(Object.keys(section));
                    });
                    properties[contentType] = contentPropertiesNames;
                });
                return properties;
            },
            getDefinitionForType: function (elementType) {
                let typeDefinition = {};
                if (elementType === undefined) {
                    return;
                }

                let contentTypeArrays = [["template", "t_"], ["campaign", "c_"], ["publish", "p_"]];

                if (elementsSettingsDefinition[elementType] !== undefined) {
                    typeDefinition['all'] = JSON.parse(JSON.stringify(elementsSettingsDefinition[elementType]));
                }
                _.each(contentTypeArrays, (contentTypeArray) => {
                    let currentTypeDefinition = {};
                    if (elementsSettingsDefinition[elementType] !== undefined && elementsSettingsDefinition[contentTypeArray[1] + elementType] !== undefined) {
                        currentTypeDefinition = JSON.parse(JSON.stringify(elementsSettingsDefinition[elementType]));
                        _.each(elementsSettingsDefinition[contentTypeArray[1] + elementType], function (section, key) {
                            if(currentTypeDefinition[key] !== undefined) {
                                Object.assign(currentTypeDefinition[key], section);
                            } else {
                                currentTypeDefinition[key] = JSON.parse(JSON.stringify(section));
                            }
                        });
                    } else if (elementsSettingsDefinition[elementType] !== undefined) {
                        currentTypeDefinition = elementsSettingsDefinition[elementType];
                    } else if (elementsSettingsDefinition[contentTypeArray[1] + elementType] !== undefined) {
                        currentTypeDefinition = elementsSettingsDefinition[contentTypeArray[1] + elementType];
                    }
                    typeDefinition[contentTypeArray[0]] = currentTypeDefinition;
                });

                return typeDefinition;
            },
        },
        mounted: function () {
            let content_presets = JSON.parse(this.content_presets);
            this.allElementTypes = Object.keys(content_presets);
            this.allElementTypes.splice(0,4);

            _.each(this.allElementTypes, (elementType) => {
                if(typeof content_presets[elementType] === 'undefined' || content_presets[elementType] == null || Object.keys(content_presets[elementType]).length === 0) {
                    content_presets[elementType] = this.initProperties(elementType);
                } else {
                    content_presets[elementType] = this.initProperties(elementType, JSON.parse(content_presets[elementType]));
                }
            });
            this.inner_content_presets = content_presets;

            if (Laravel.switch_off_times === true) {
                this.all_layer_layers = _.remove(JSON.parse(this.all_layers), function (o) {
                    return o.nr !== 0;
                });
            } else {
                this.all_layer_layers = JSON.parse(this.all_layers);
            }
            this.contentType = this.allContentTypes[0];
            this.elementType = this.allElementTypes[0];
            this.updateInnerProperties();

            this.processWindowSize();
            this.$nextTick(() => {
                window.addEventListener('resize', this.processWindowSize);
            });
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.processWindowSize);
        }
    }
</script>
